import React from "react";

export const getResumePreviewUrl = url => {
  if (!url) return "";

  const resumeUrl = String(url);
  const cleanUrl = resumeUrl.split(/[?#]/)[0].toLowerCase();
  let cleanPath = cleanUrl;

  try {
    cleanPath = decodeURIComponent(new URL(resumeUrl, window.location.origin).pathname).toLowerCase();
  } catch (error) {
    cleanPath = cleanUrl;
  }

  if (cleanPath.endsWith(".pdf") || cleanUrl.endsWith(".pdf")) {
    return resumeUrl.includes("#") ? resumeUrl : `${resumeUrl}#toolbar=1&navpanes=1&scrollbar=1`;
  }

  if (cleanPath.endsWith(".doc") || cleanPath.endsWith(".docx") || cleanUrl.endsWith(".doc") || cleanUrl.endsWith(".docx")) {
    return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(resumeUrl)}`;
  }

  return `https://docs.google.com/gview?url=${encodeURIComponent(resumeUrl)}&embedded=true`;
};

const ResumePreviewPanel = ({
  resumeUrl,
  title = "Resume Preview",
  height = "100%",
  minHeight = "520px",
  showShellBorder = true,
  wrapperStyle = {},
  bodyStyle = {},
  iframeStyle = {},
}) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      height,
      minHeight,
      background: "#f8fafc",
      border: showShellBorder ? "1px solid #dbe4f0" : "none",
      borderRadius: showShellBorder ? 10 : 0,
      overflow: "hidden",
      ...wrapperStyle,
    }}
  >
    <div
      style={{
        padding: "0.85rem 1.25rem",
        borderBottom: "1px solid #dbe4f0",
        background: "#fff",
        fontWeight: 700,
        fontSize: 13,
        color: "#0f172a",
      }}
    >
      {title}
    </div>

    <div
      style={{
        flex: 1,
        padding: "0.75rem",
        display: "flex",
        minHeight: 0,
        ...bodyStyle,
      }}
    >
      {resumeUrl ? (
        <iframe
          src={getResumePreviewUrl(resumeUrl)}
          title={title}
          style={{
            width: "100%",
            height: "100%",
            minHeight: 0,
            borderRadius: 10,
            border: "1px solid #dbe4f0",
            background: "#2b2b2b",
            ...iframeStyle,
          }}
        />
      ) : (
        <div
          className="m-auto d-flex flex-column align-items-center text-center"
          style={{
            width: "min(420px, 86%)",
            padding: "34px 28px",
            border: "1px dashed #93c5fd",
            borderRadius: 16,
            background: "linear-gradient(180deg, #eff6ff 0%, #ffffff 100%)",
            boxShadow: "0 16px 34px rgba(15, 76, 129, 0.08)",
            color: "#334155",
          }}
        >
          <img
            alt="Resume missing"
            src={`data:image/svg+xml;utf8,${encodeURIComponent(`
              <svg xmlns="http://www.w3.org/2000/svg" width="150" height="110" viewBox="0 0 150 110" fill="none">
                <rect x="33" y="10" width="68" height="86" rx="10" fill="#FFFFFF" stroke="#93C5FD" stroke-width="2"/>
                <path d="M84 10v20c0 4.418 3.582 8 8 8h9" fill="#DBEAFE"/>
                <path d="M84 10v20c0 4.418 3.582 8 8 8h9" stroke="#93C5FD" stroke-width="2"/>
                <circle cx="67" cy="44" r="11" fill="#BFDBFE"/>
                <path d="M47 75c2.963-10.716 9.41-16 20-16s17.037 5.284 20 16" fill="#DBEAFE"/>
                <path d="M48 82h38" stroke="#60A5FA" stroke-width="3" stroke-linecap="round"/>
                <path d="M48 89h28" stroke="#BFDBFE" stroke-width="3" stroke-linecap="round"/>
                <circle cx="107" cy="75" r="18" fill="#EFF6FF" stroke="#60A5FA" stroke-width="2"/>
                <path d="M99.5 75h15" stroke="#2563EB" stroke-width="3" stroke-linecap="round"/>
                <path d="M107 67.5v15" stroke="#2563EB" stroke-width="3" stroke-linecap="round"/>
                <circle cx="35" cy="88" r="5" fill="#DBEAFE"/>
                <circle cx="112" cy="28" r="6" fill="#BFDBFE"/>
              </svg>
            `)}`}
            style={{
              width: 150,
              maxWidth: "72%",
              height: "auto",
              marginBottom: 12,
              filter: "drop-shadow(0 14px 20px rgba(15, 76, 129, 0.12))",
            }}
          />
          <strong style={{ fontSize: 16, color: "#0f172a", marginBottom: 5 }}>
            Resume not uploaded
          </strong>
          <span style={{ fontSize: 13, color: "#64748b", lineHeight: 1.45 }}>
            Upload a resume to preview the candidate profile here.
          </span>
        </div>
      )}
    </div>
  </div>
);

export default ResumePreviewPanel;
